import { useEffect } from "react";

/** `enabled: false` leaves the tab title alone, for a page shown inside another
 *  page that already set it. */
export function useDocumentTitle(title: string, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const prev = document.title;
    document.title = title ? `${title} — ProClaw` : "ProClaw";
    return () => { document.title = prev; };
  }, [title, enabled]);
}
